// @flow

import React, { type Node } from 'react';
import { Helmet } from 'react-helmet';
import faviconSrc from '@tectonics/favicon.svg';
import { type LookAndFeelRootPropsOpenedPayment } from '@tectonics/look-and-feel';
import { PaymentSpecProvider } from '@tectonics/prs/payment-spec';
import { SelectedPaymentMethodProvider } from '@tectonics/prs/selected-payment-method';
import { UserInputValuesProvider } from '@tectonics/prs/user-input-values';
import { SubmittingProvider } from '@tectonics/prs/submitting';
import { FormStatusContextProvider } from '@tectonics/prs/form-status';
import { ValidationProvider } from '@tectonics/prs/validation';
import { AnalyticsContextProvider, AnalyticsCachedEvent } from '@tectonics/analytics';
import { SetInitialPaymentMethod } from '@tectonics/components';
import lookAndFeel from '../..';

import { Template } from '../../template';
import { Main } from './main';
import { IncomingPaymentProvider, getMerchant } from '@tectonics/prs/incoming-payment';
import { getName } from '@tectonics/prs/merchant';
import { ValuesDisplay } from '../../commons/organisms/values-display/index';
import { Footer } from '../../commons/organisms/footer';

export function OpenedPaymentPage({
  spec,
  selectedPaymentMethod,
  incomingPayment,
  submitting,
  onSelectPaymentMethod,
  userInputValues,
  onUserInput,
  onSubmit,
  userInputValidationErrors,
  submitError,
  analytics,
}: LookAndFeelRootPropsOpenedPayment): Node {
  const merchant = getMerchant(incomingPayment);

  return (
    <PaymentSpecProvider spec={spec}>
      <IncomingPaymentProvider incomingPayment={incomingPayment}>
        <UserInputValuesProvider values={userInputValues} setValue={onUserInput}>
          <SelectedPaymentMethodProvider selected={selectedPaymentMethod} setSelectedByCode={onSelectPaymentMethod}>
            <ValidationProvider userInputValidationErrors={userInputValidationErrors} submitError={submitError}>
              <SubmittingProvider submitting={submitting}>
                <FormStatusContextProvider>
                  <AnalyticsContextProvider analytics={analytics}>

                    <AnalyticsCachedEvent eventType="pageView" />

                    <SetInitialPaymentMethod lookAndFeel={lookAndFeel} />

                    <Helmet
                      title={`Página de pagamento${merchant && ` - ${getName(merchant)}`}`}
                      link={[{ rel: 'icon', href: faviconSrc }]}
                    />

                    <Template
                      mainContent={<Main onSubmit={onSubmit} />}
                      displayContent={<DisplayContent />}
                      footerContent={<FooterContent />}
                    />

                  </AnalyticsContextProvider>
                </FormStatusContextProvider>
              </SubmittingProvider>
            </ValidationProvider>
          </SelectedPaymentMethodProvider>
        </UserInputValuesProvider>
      </IncomingPaymentProvider>
    </PaymentSpecProvider>
  );

}

function DisplayContent(): Node {
  return (
    <ValuesDisplay />
  );
}

function FooterContent(): Node {
  return (
    <Footer/>
  );
}
